module.exports  = function iconNameToIcon(name) {
	if (name.indexOf('fa-') === 0)
		return 'glyphicons fa ' + name;
	return 'glyphicons glyphicons-' + name;
}